export const prod = true;

export const typeName = "__typename";

export const appLocales = [
  "en-US",
  "de-DE",
  "da-DA",
  "es-ES",
  "fr_FR",
  "nl_NL",
  "it_IT",
  "pt_PT",
  "sr_RS",
];
export const STORE_ID = "10701";
export const MARKET_ID = "3071";

export const telephoneRequiredStoreIds = [
  10705, 84009904, 24009404, 44009504, 64009604, 54009554, 34009454,
];

export const forms = {
  // TEST
  34009450: "3412119e-a869-4878-a04f-074df5d6dd37",
  // ALEMANIA
  10705: "c8499a6f-bb48-49b1-87d6-066ca7925c7c",
  84009904: "9a559ebb-f612-4568-9089-dd5af5bcbf06",
  24009404: "27f9ccb0-d677-46bf-bcc8-6e9d49f26ce1",
  44009504: "24e58d81-ab79-4eb9-98cb-6079a4fd4cb6",
  64009604: "6d503530-1123-41a3-b1f3-9c6995f59496",
  54009554: "f48fe69b-c8d4-4344-82e6-1af88e849579",
  34009454: "0d823267-ee68-4591-9f32-fa324bd48fb1",
  // HOLANDA
  11709: "10e5f4a5-3c18-41bc-9d12-24bf8cd9c059",
  84009903: "76b691c3-3d57-4827-83c8-f266d31003f4",
  24009403: "9d441a4e-7572-4333-8ef8-4c7400d7087b",
  44009503: "38412864-4d32-4fe4-a708-f16de1d886b4",
  65009603: "11783377-2572-4c1e-b9a7-ce78c647abb1",
  54009553: "a6f22c01-f3d5-42e3-928c-4e050c62eb3a",
  34009453: "e7b5889d-3554-4026-a520-0ae9db6b4754",
  // GRECIA
  11708: "7e05b569-09af-4a82-b45a-7ac7af2d0044",
  84009909: "1853ca2a-74f5-495f-9744-c8d0b64d8b7a",
  24009509: "73ca1c01-0290-4311-9a7a-cc472c82d16a",
  45109509: "7b26a284-77db-4b02-9f81-8f4bb78d4bd2",
  65009609: "cb704e26-eb46-45ca-9b70-b59865c80cd8",
  55009559: "351c6d77-a26f-4745-837d-9349a72fa04a",
  34009459: "1dd1363b-2b80-4759-8481-86f7fa7e6327",
  // BELGICA
  34009452: "ab4e2833-ea36-4455-8df6-3e7c8926fecb",
  64009602: "f1b46c6d-730a-499a-a306-7bc9c5dae98e",
  45109502: "6a12e544-e327-4f89-b374-79f9848ae24e",
  84009902: "730d4ecc-ff2e-49c6-a021-141a42e37427",
  54009552: "92b2308e-6aeb-4ecf-9eb2-fd4a76e69f15",
  24009502: "7183faf1-9d89-4281-b3a2-54b11bb5f52e",
  11703: "ddbaef8b-fc99-4d92-85c8-44f13cd40aa5",
  //Irlanda
  34009457: "1f8d0e2d-842f-420c-84dc-8cc708b6f872",
  45109507: "7bb86a68-4dd6-4932-9819-2dd114ec65a1",
  55009557: "7c96ffcb-9f78-40ab-b206-90597e0423ea",
  11710: "c15d5c4d-efd9-4ac1-a881-ae29c4d65e3b",
  24009507: "5fb2b4bc-8da7-44a4-9a5c-c3c238371e93",
  //China
  11716: "de013cd7-39a9-410b-9a96-db651a9141b5",
};

export const tokens = {
  // TEST
  34009450: "d0c3432c-130b-4b36-84d4-1a81d4388dcb",
  // ALEMANIA
  10705: "55489868-befe-437a-80a0-85a6fa42057a",
  84009904: "4d4c2da4-e847-4007-9d34-a75b28997bf0",
  24009404: "a7206ccc-b68d-43fd-8935-8c0f234bf875",
  44009504: "b08281d7-00fa-49b2-b2c7-e42245628004",
  64009604: "e18a30e1-9c93-4ec8-b198-74d560cfb379",
  54009554: "480861f0-e5ee-48c8-9dd0-d02d968efe5f",
  34009454: "a51ddfab-9862-4c50-bfcd-3fdf3acaa59c",
  // HOLANDA
  11709: "30866409-156f-4d4f-9c65-f98e01adaa8f",
  84009903: "4f968e66-c7ea-47c1-a970-05d131d86898",
  24009403: "acb0886f-5789-4cde-bef1-0b190a9eacf1",
  44009503: "7142b814-b7c0-49ca-9d66-fca67ef2d3b4",
  65009603: "be154d45-812d-470e-8f03-8327e5e223a3",
  54009553: "5e65f3f7-ce86-4804-a439-64b98b22aaab",
  34009453: "933be099-213f-43ae-a53f-5385ded90fdd",
  // GRECIA
  11708: "75b9eb6c-28c7-412a-89b6-5eb7ef8fb1d9",
  84009909: "2d0ac2bf-b62f-4658-a013-841ee346527f",
  24009509: "1977e56a-76d9-4750-9404-c3130531b74b",
  45109509: "0fdfc409-6ac0-40b9-81d0-89e3d9e0af55",
  65009609: "8bc06a0e-7da7-48bf-9089-2b68d2211088",
  55009559: "e8f6d70f-df66-4334-9238-fcc4fc5e2aba",
  34009459: "e976ed72-69de-4911-976b-fb7672237f8b",
  // BELGICA
  34009452: "30bb1e00-ab11-4b05-ac21-5195fb121c36",
  64009602: "0ff94afa-9489-4deb-9cf7-78180b13dd1c",
  45109502: "0a525659-5f7a-47fd-9ccf-3a42f13597b0",
  84009902: "ff3481d1-71b3-4e62-ae44-b01013e0b785",
  54009552: "a4ea7918-c496-401b-83e6-a11dfddc0796",
  24009502: "eb69a7b5-682a-4040-be11-95ba43f5f8f4",
  11703: "723f92fa-35b9-4185-ba40-4b567081801b",
  //Irlanda
  34009457: "22652e4a-1eb6-42a3-a67b-a232b8978c36",
  45109507: "c0c4adda-0200-4efc-9c75-3a9b84383000",
  55009557: "e50d98ab-7fcf-4885-b7ff-eed15d2fb20c",
  11710: "f04b6aa5-5c23-4d69-819e-0505c4db547c",
  24009507: "3180bd42-601b-4e9c-b44a-aaf5e93f17e3",
  //China
  11716: "6f176da1-960d-4a09-9f18-2cb9d83bfee7",
};

export const brands = [
  "bk",
  "md",
  "oy",
  "lf",
  "pb",
  "st",
  "ut",
  "za",
  "zh",
  "zacn",
];

export const brandsUrl = {
  za: "zara.com",
  bk: "bershka.com",
  pb: "pullandbear.com",
  md: "massimodutti.com",
  oy: "oysho.com",
  st: "stradivarius.com",
  zh: "zarahome.com",
  lf: "lefties.com",
  ut: "uterque.com",
  zacn: "zara.cn",
};
